/**
 * The composition percentage is stored as a fraction and shown as a percentage.
 *
 * The rule used to live in `reducingOptions/rawMaterials`, applied to the
 * `substances` and `mixtures` arrays the raw material carried: every screen that
 * showed a composition percentage read one of those two, so every screen showed
 * `stored * 100`, and the one screen that writes one back divides by 100 again.
 *
 * Those arrays are now the mixtures slice - the same mixture_substance rows,
 * fetched on their own - so the rule moves here with them, unchanged. Without
 * it every composition table, report and export shows a hundredth of what it
 * showed before.
 *
 * ⚠️ `toFixed` returns a string, and a null percentage becomes "0.00000" rather
 * than staying null. Both are what the raw material's copy did, and the columns
 * that render it - `parseFloat(rowData.percentage)` - were written against that.
 */
export default {
  sanitizers: {
    percentage: value => (value * 100).toFixed(5)
  }
};
